// import axios from 'axios'
import Vue from "vue";
import Vuex from "vuex";
import { baseApiUrl } from "./global";
import { VueEasyJwt } from "vue-easy-jwt";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    counterLoader: 0,
    user: null,
    ufAll: null,
    token: null,
    paisAll: null,
    urlPDF: null,
    idCiclo: null,
    userName: null,
    dadosPDF: null,
    exercicio: null,
    idenPessoa: null,
    msgUsuario: null,
    cicloPessoa: null,
    modalidades: null,
    userLogado: false,
    dadosPessoa: null,
    etapasCliclo: null,
    loaderAtivo: false,
    userValidacao: null,
    areaformacoes: null,
    idenCicloEtapa: null,
    tokenrecaptcha: null,
    orgaoDocumentos: null,
    servSelecionado: null,
    cicloSelecionado: null,
    areasConhecimento: null,
    formacaoContinuada: null,
    perguntaSelecionada: null,
    parametroEmailEditar:null,
    cicloEditarDados:null,
    paginaGerencia: "gerenciaCiclo",
    perguntasQuestionario: [],
    novasperguntaSelecionadasParaQuestionario: [],
    questionarioSelecionado: { descQuestionario: null },
    versaoApi: "1.0.0",
    filtros:[
      {
          namePagina:''         
      }
    ],

  },
  getters: {
    getcounterLoader(state) {
      return state.counterLoader;
    },
    getPaginaGerencia(state) {
      return state.paginaGerencia;
    },
    isUserLogado(state) {
      // Retorna o estado
      return state.userLogado;
    },
    isloader(state) {
      return state.loaderAtivo;
    },
    getUser(state) {
      return state.user ? JSON.parse(state.user) : null;
      //return state.user? JSON.parse(atob(state.user)) : null
    },
    getToken(state) {
      return state.token ? JSON.parse(state.token) : null;
    },
    getIdenPessoa(state) {
      return state.idenPessoa ? state.idenPessoa : "Valor default";
    },
    getUrlPDF(state) {
      return state.urlPDF ? state.urlPDF : null;
    },
    getIdCiclo(state) {
      return state.idCiclo;
    },
    getDadosPDF(state) {
      return state.dadosPDF ? JSON.parse(state.dadosPDF) : null;
    },
    getExercicio(state) {
      return state.exercicio;
    },
    getDadosPessoa(state) {
      return state.dadosPessoa ? JSON.parse(state.dadosPessoa) : null;
    },
    getCicloPessoa(state) {
      return state.cicloPessoa ? JSON.parse(state.cicloPessoa) : null;
    },
    getEtapasCiclo(state) {
      return state.etapasCliclo ? JSON.parse(state.etapasCliclo) : null;
    },
    getUf(state) {
      return state.ufAll;
    },
    getPais(state) {
      return state.paisAll;
    },
    getTokenrecaptcha(state) {
      return state.tokenrecaptcha;
    },
    getOrgaoDocumentos(state) {
      return state.orgaoDocumentos;
    },
    getAreasConhecimento(state) {
      return state.areasConhecimento;
    },
    getUserValidacao(state) {
      return state.userValidacao;
    },
    getFormacaoContinuadas(state) {
      return state.formacaoContinuada;
    },
    getModalidades(state) {
      return state.modalidades;
    },
    getAreaFormacoes(state) {
      return state.areaformacoes;
    },
    getServSelecionado(state) {
      return state.servSelecionado;
    },
    getVersaoApi(state) {
      return state.versaoApi;
    },
    getCicloSelecionado(state) {
      return state.cicloSelecionado;
    },
    getQuestionarioSelecionado(state) {
      return state.questionarioSelecionado;
    },
    getPerguntasQuestionario(state) {
      return state.perguntasQuestionario;
    },
    getNovasperguntaSelecionadasParaQuestionario(state) {
      return state.novasperguntaSelecionadasParaQuestionario;
    },
    getPerguntaSelecionada(state) {
      return state.perguntaSelecionada;
    },
    getParametroEmailEditar(state) {
      return state.parametroEmailEditar;
    },
    getCicloEditarDados(state){
      return state.cicloEditarDados;
    },
    getMsgUsuario(state) {
      return state.msgUsuario;
    },
    getFiltros(state){
      return state.filtros
    },

  },
  mutations: {
    setPaginaGerencia(state, paginaAtual) {
      state.paginaGerencia = paginaAtual;
    },
    setUser(state, user) {
      state.user = user ? user : null;
      //state.user = user? btoa(user) : null
      state.userName = user
        ? JSON.parse(user).contaAcesso.nomeApresentacao
        : null;
    },
    setToken(state, token) {
      state.token = token ? token : null;
    },
    setUserLogado(state, isUserLogado) {
      state.userLogado = isUserLogado;
    },
    setLoader(state, loaderStatus) {
      state.loaderAtivo = loaderStatus;
    },
    setIdenPessoa(state, idenPessoa) {
      state.idenPessoa = idenPessoa;
    },
    setUrlPDF(state, urlPDF) {
      state.urlPDF = urlPDF ? urlPDF : null;
    },
    setIdCiclo(state, id) {
      state.idCiclo = id;
    },
    setDadosPDF(state, dadosPDF) {
      state.dadosPDF = dadosPDF ? dadosPDF : null;
    },
    setExercicio(state, exercicio) {
      state.exercicio = exercicio;
    },
    setCicloPessoa(state, cicloPessoa) {
      state.cicloPessoa = cicloPessoa ? cicloPessoa : null;
    },
    setEtapasCiclo(state, etapasCliclo) {
      state.etapasCliclo = etapasCliclo;
    },
    setDadosPessoa(state, dadosPessoa) {
      state.dadosPessoa = dadosPessoa ? dadosPessoa : null;
    },
    setTokenrecaptcha(state, tokenrecaptcha) {
      state.tokenrecaptcha = tokenrecaptcha;
    },
    setUf(state, uf) {
      state.ufAll = uf;
    },
    setPais(state, pais) {
      state.paisAll = pais;
    },
    setOrgaoDocumentos(state, orgaoDocumentos) {
      state.orgaoDocumentos = orgaoDocumentos;
    },
    setAreasConhecimento(state, areasConhecimento) {
      state.areasConhecimento = areasConhecimento;
    },
    setFormacaoContinuadas(state, formacaoContinuada) {
      state.formacaoContinuada = formacaoContinuada;
    },
    setModalidades(state, modalidades) {
      state.modalidades = modalidades;
    },
    setUserValidacao(state, userValidacao) {
      state.userValidacao = userValidacao;
    },
    setAreaFormacoes(state, areaformacoes) {
      state.areaformacoes = areaformacoes;
    },
    setServSelecionado(state, servSelecionado) {
      state.servSelecionado = servSelecionado;
    },
    setVersaoApi(state, versaoApi) {
      state.versaoApi = versaoApi;
    },
    setCicloSelecionado(state, cicloSelecionado) {
      state.cicloSelecionado = cicloSelecionado;
    },
    setQuestionarioSelecionado(state, questionarioSelecionado) {
      state.questionarioSelecionado = questionarioSelecionado;
    },
    setPerguntasQuestionario(state, perguntasQuestionario) {
      state.perguntasQuestionario = perguntasQuestionario;
    },
    setNovasperguntaSelecionadasParaQuestionario(
      state,
      novasperguntaSelecionadasParaQuestionario
    ) {
      state.novasperguntaSelecionadasParaQuestionario = novasperguntaSelecionadasParaQuestionario;
    },
    setPerguntaSelecionada(state, perguntaSelecionada) {
      state.perguntaSelecionada = perguntaSelecionada;
    },
    setParametroEmailEditar(state, parametroEmailEditar){
        state.parametroEmailEditar = parametroEmailEditar
    },
    setCicloEditarDados(state, cicloEditarDados){
      state.cicloEditarDados = cicloEditarDados
    },
    setMsgUsuario(state, msgUsuario) {
      state.msgUsuario = msgUsuario;
    },
    incCounterLoader(state) {
      state.counterLoader++;
    },
    decCounterLoader(state) {
      state.counterLoader--;
    },
    zeraCounterLoader(state) {
      state.counterLoader = 0;
    },
    setFiltros(state,filtro){
      if(state.filtros.some( (element) => element.namePagina === filtro.namePagina)){
          state.filtros = state.filtros.map(pFiltro =>{
              if (pFiltro.namePagina === filtro.namePagina){
                  return {...filtro}
              }
              return {...pFiltro}
          })
      }else{
          state.filtros.push(filtro)
      }

    },

  },
  actions: {
    logarUsuario(context, payload) {
      let formData = new FormData();
      formData.append("client", process.env.VUE_APP_USERNAME_API);
      formData.append("username", payload.login);
      formData.append("password", payload.senha);
      formData.append("grant_type", "password");

      delete payload.vue.$http.defaults.headers.common["Content-Type"];
      payload.vue.$http.defaults.headers.common[
        "Authorization"
      ] = `Basic ${btoa(
        process.env.VUE_APP_USERNAME_API +
          ":" +
          process.env.VUE_APP_PASSWORD_API
      )}`;

      payload.vue.$http
        .post(`${baseApiUrl}/oauth/token`, formData, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
          },
        })
        .then((res) => {
          payload.vue.$toast.removeAllGroups();

          var userlogado = {
            token: JSON.stringify(res.data),
            login: payload.login,
          };

          localStorage.setItem(
            process.env.VUE_APP_USER_KEY,
            btoa(JSON.stringify(userlogado))
          );
          context.commit("setToken", JSON.stringify(res.data));
          context.dispatch("buscarUsuario", payload.vue);
          context.commit("setLoader", false);
          context.commit("setUserLogado", true);

          if (process.env.VUE_APP_ATIVAR_GOOGLE_TOOLS != "false") {
            payload.vue.$recaptchaInstance.hideBadge();
          }

          return true;
        })
        .catch((error) => {
          context.dispatch("logoutUsuario");
          payload.vue.$toast.removeAllGroups();
          if (error.response.data.error_description == "Bad credentials") {
            payload.vue.$toast.add({
              severity: "error",
              summary: "Usuario ou senha invalida!!",
              life: 3000,
            });
          } else {
            if (error.response.data.error == "unauthorized") {
              payload.vue.$toast.add({
                severity: "error",
                summary: error.response.data.error_description,
                life: 3000,
              });
            } else {
              payload.vue.$toast.add({
                severity: "error",
                summary: "Ocorreu um erro na execução dessa operação",
                life: 3000,
              });
            }
          }

          return false;
        });
    },
    async buscarUsuario(context, vue) {
      let res = await vue.$http.get(`${baseApiUrl}/seguranca/contasacesso/me`);
      if (res.status == 200) {
        // res.map(item => item.contaAcesso.authorities.filter(
        //     subItem => subItem.authority == "FORMPREFEITURA_MENU" && subItem.authority == "FORMPREFEITURA_FORMULARIO"
        // ))
        context.commit("setUser", JSON.stringify(res.data));
        context.commit("setIdenPessoa", res.data.contaAcesso.pessoa.idenPessoa);
        // vue.$http.put(`${baseApiUrl}/ciclopessoas/verifica-ciclo-pessoa-publico-alvo/${context.getters.getIdenPessoa}`)
        context.dispatch("buscarCicloPessoa", vue);
        vue.$http.get(`${baseApiUrl}/publicos/sistemas/versao`).then((res) => {
          context.commit("setVersaoApi", res.data);
        });

        if (process.env.VUE_APP_ATIVAR_GOOGLE_TOOLS != "false") {
          await vue.$recaptchaLoaded();
          vue.$recaptchaInstance.hideBadge();
        }
      } else {
        context.dispatch("logoutUsuario");
      }
      return true;
    },

    async buscarCicloPessoa(context, vue) {
      // vue.$http.put(`${baseApiUrl}/ciclopessoas/verifica-ciclo-pessoa-publico-alvo/${context.getters.getIdenPessoa}`)
      let res2 = await vue.$http.get(
        `${baseApiUrl}/ciclopessoas/resumo/${context.getters.getIdenPessoa}`
      );
      if (res2.status == 200) {
        context.commit("setCicloPessoa", JSON.stringify(res2.data));
      } else {
        context.commit("setMsgUsuario", JSON.stringify(res2.data.msgUsuario));
      }
      return true;
    },

    logoutUsuario(context) {
      localStorage.removeItem(process.env.VUE_APP_USER_KEY);
      context.commit("setUserLogado", false);
      context.commit("setToken", null);
      context.commit("setUser", null);
      context.commit("setCicloPessoa", null);
      context.commit("setDadosPessoa", null);
      context.commit("setIdenPessoa", null);
    },

    async refreshToken(context, vue) {
      var formData = new URLSearchParams();
      formData.append("grant_type", "refresh_token");

      delete vue.$http.defaults.headers.common["Content-Type"];

      vue.$http.defaults.headers.common["Authorization"] = `Basic ${btoa(
        process.env.VUE_APP_USERNAME_API +
          ":" +
          process.env.VUE_APP_PASSWORD_API
      )}`;

      if (process.env.VUE_APP_ATIVAR_GOOGLE_TOOLS != "false") {
        await vue.$recaptchaLoaded();
      }

      let res = await vue.$http
        .post(`${baseApiUrl}/oauth/token`, formData, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
          },
        })
        .catch(() => {
          vue.$toast.add({
            severity: "error",
            summary: "Sua sessão expirou! Por favor faça login novamente",
            life: 3000,
          });
          context.dispatch("logoutUsuario");
          if (process.env.VUE_APP_ATIVAR_GOOGLE_TOOLS != "false") {
            vue.$recaptchaInstance.showBadge();
          }
          return false;
        });

      if (res && res.status == 200) {
        let token = JSON.parse(
          atob(localStorage.getItem(process.env.VUE_APP_USER_KEY))
        );
        token.token = JSON.stringify(res.data);
        localStorage.setItem(
          process.env.VUE_APP_USER_KEY,
          btoa(JSON.stringify(token))
        );
        context.commit("setToken", JSON.stringify(res.data));
        context.commit("setUserLogado", true);
        return true;
      }
    },
    async verificaToken(context, vue) {
      let jwt = new VueEasyJwt();
      if (jwt.isExpired(context.getters.getToken.access_token)) {
        await context.dispatch("refreshToken", vue);
      }
    },
  },
});
